import { EnvironmentModel } from './environment.model'

export function env(): EnvironmentModel {
  return {
    stage: 'env-test',
    api: {
      url: 'https://tst-patienten-selfservice.azurewebsites.net/api',
    },
  }
}
